import { render, staticRenderFns } from "./ToeflJuniorScoreComponent.vue?vue&type=template&id=701cbf32&scoped=true&"
import script from "./ToeflJuniorScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflJuniorScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflJuniorScoreComponent.vue?vue&type=style&index=0&id=701cbf32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701cbf32",
  null
  
)

export default component.exports